RivalIQ.apps.Dashboard.module('mixins', function (mixins, App, Backbone, Marionette, $, _) {

    'use strict';

    mixins.Title = {
        getTitle: function (format) {
            const me = this;

            switch (format || me.getProp('format')) {
                case RivalIQ.enums.exportFormat.PNG:
                    return me.getPngTitle();
                case RivalIQ.enums.exportFormat.PDF:
                    return me.getPdfTitle();
                case RivalIQ.enums.exportFormat.PPT:
                    return me.getPptTitle();
                default:
                    return _.result(me, 'title');
            }
        },

        getExportTitle: function () {
            const me = this;
            return me.exportTitle || _.result(me, 'title');
        },

        getPngTitle: function () {
            const me = this;

            return me.pngTitle || me.getExportTitle();
        },

        getPdfTitle: function () {
            const me = this;

            return me.pdfTitle || me.getExportTitle();
        },

        getPptTitle: function () {
            const me = this;
            return me.pptTitle || me.getExportTitle();
        },

        getSubtitle: function () {
            const me = this;

            switch (me.getProp('format')) {
                case RivalIQ.enums.exportFormat.PNG:
                    return me.getPngSubtitle();
                case RivalIQ.enums.exportFormat.PDF:
                    return me.getPdfSubtitle();
                case RivalIQ.enums.exportFormat.PPT:
                    return me.getPptSubtitle();
                default:
                    return _.result(me, 'subtitle');
            }
        },

        getExportSubtitle: function () {
            const me = this;
            return me.exportSubtitle || _.result(me, 'subtitle');
        },

        getPptSubtitle: function () {
            const me = this;
            return me.pptSubtitle || me.getExportSubtitle();
        },

        getPngSubtitle: function () {
            const me = this;
            return me.pngSubtitle || me.getExportSubtitle();
        },

        getPdfSubtitle: function () {
            const me = this;
            return me.pdfSubtitle || me.getExportSubtitle();
        }
    };

    mixins.FocusCompanyTitlePlacementMixin = {
        getTitle: function (format, options) {
            const me = this;

            let title;
            switch (format || me.getProp('format')) {
                case RivalIQ.enums.exportFormat.PNG:
                    title = me.getPngTitle();
                    break;

                case RivalIQ.enums.exportFormat.PDF:
                    title = me.getPdfTitle();
                    break;

                case RivalIQ.enums.exportFormat.PPT:
                    title = me.getPptTitle();
                    break;

                default:
                    title = _.result(me, 'title');
            }

            if (!_.get(options, 'omitFocusCompanyTitle')) {

                const focusCompanyTitlePlacement = me.getProp('focusCompanyTitlePlacement');
                if (focusCompanyTitlePlacement && focusCompanyTitlePlacement !== RivalIQ.enums.widgetFocusCompanyTitlePlacement.NONE) {
                    const focusCompany = RivalIQ.state.landscape.getCompanyById(me.getProp('focusCompanyId'));
                    const companyName = (focusCompany ? focusCompany.get('name') : '');
                    if (focusCompanyTitlePlacement === RivalIQ.enums.widgetFocusCompanyTitlePlacement.PREFIX) {
                        title = `${companyName} ${title}`;
                    } else {
                        title += ` ${companyName}`;
                    }
                }
            }

            return title;
        }
    };
});
